import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const TwoColumnsImageAnimation = () => {
  const containers = document.querySelectorAll(".two-columns-image");
  if (containers.length < 1) {
    return;
  }

  const reduceMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;
  if (reduceMotion) return;

  const base = {
    y: 0,
    opacity: 1,
    duration: 1,
    ease: "power2.inOut",
  };
  const applyAnimations = () => {
    containers.forEach((container) => {
      const imageHeadline = container.querySelectorAll(".image-headline");
      const headline = container.querySelectorAll(
        ".two-columns-image__headline",
      );
      const subline = container.querySelectorAll(".two-columns-image__subline");
      const image = container.querySelectorAll(".two-columns-image__image");
      const icon = container.querySelectorAll(".text-content__icon");
      const textHeadline = container.querySelectorAll(
        ".text-content__headline",
      );
      const text = container.querySelectorAll(".text-content__text");

      if (
        !imageHeadline.length &&
        !headline.length &&
        !subline.length &&
        !text.length &&
        !image.length &&
        !textHeadline.length
      )
        return;

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: container,
          start: "top 80%",
          once: true,
          fastScrollEnd: true,
        },
      });

      if (imageHeadline.length) {
        tl.to(imageHeadline, { ...base, x: 0 }, 0);
      }

      if (headline.length) {
        tl.to(headline, { ...base, x: 0 }, 0);
      }

      if (subline.length) {
        tl.to(subline, { ...base, x: 0 }, 0.2);
      }

      if (icon.length) {
        tl.to(icon, { ...base, scale: 1 }, 0.2);
      }

      if (textHeadline.length) {
        tl.to(textHeadline, base, 0.2);
      }

      if (text.length) {
        tl.to(text, base, 0.4);
      }

      if (image.length) {
        tl.to(
          image,
          { opacity: 1, duration: 1, ease: "back.out(1.7, 0.5)", scale: 1 },
          0.4,
        );
      }
    });
  };
  applyAnimations();
};

export default TwoColumnsImageAnimation;
